<!-- src/components/comparisons/PettyCashVsRevenueCard.vue -->
<template>
  <ComparisonContentCard
    title="Petty Cash vs Revenue"
    :subtitle="subtitle"
    :rag="rag"
    :tiles="tiles"
    :tintCard="true"
  >
    <p v-if="loading" class="grey-text">Loading petty cash KPI…</p>

    <p v-else-if="error" class="red-text">
      {{ error }}
    </p>

    <template v-else>
      <div class="core-table-wrap">
        <table class="highlight core-table core-table--nowrap">
          <thead>
            <tr>
              <th>From</th>

              <th>To</th>

              <th class="right-align">Revenue</th>

              <th class="right-align">Petty Cash</th>

              <th class="right-align">% of Revenue</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                {{ weekRange.from }}
              </td>

              <td>
                {{ weekRange.to }}
              </td>

              <td class="right-align">
                {{ fmtCurrency(actualRevenueTotal) }}
              </td>

              <td class="right-align">
                {{ fmtCurrency(pettyCashTotal) }}
              </td>

              <td class="right-align">
                <b>
                  {{ fmtPercent(pctOfRevenue) }}
                </b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </ComparisonContentCard>
</template>

<script setup>
import { computed } from "vue";

import ComparisonContentCard from "@/components/comparisons/ComparisonContentCard.vue";

import usePettyCashApi from "@/scripts/useScripts/usePettyCashApi";

import { RAG, ragLowerIsBetter } from "@/scripts/sharedHelpers/auditColours";

function fmtCurrency(v, currency = "GBP") {
  const n = Number(v);

  if (!Number.isFinite(n)) {
    return "—";
  }

  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency,
  }).format(n);
}

function fmtPercent(v, dp = 2) {
  const n = Number(v);

  if (!Number.isFinite(n)) {
    return "—";
  }

  return `${n.toFixed(dp)}%`;
}

const PETTY_PCT_THRESH = {
  greenMax: 1.0,
  amberMax: 1.5,
};

const {
  loading,
  error,
  weekRange,
  pettyCashTotal,
  actualRevenueTotal,
  pctOfRevenue,
} = usePettyCashApi();

const rag = computed(() => ragLowerIsBetter(pctOfRevenue.value, PETTY_PCT_THRESH));

const subtitle = computed(() => {
  const from = weekRange.value?.from || "—";

  const to = weekRange.value?.to || "—";

  return `${from} → ${to}`;
});

const tiles = computed(() => [
  {
    label: "Revenue",

    value: fmtCurrency(actualRevenueTotal.value),

    hint: "Weekly actual",

    rag: RAG.GREY,
  },

  {
    label: "Petty Cash",

    value: fmtCurrency(pettyCashTotal.value),

    hint: "Weekly total",

    rag: RAG.GREY,
  },

  {
    label: "% of Rev",

    value: fmtPercent(pctOfRevenue.value),

    hint: "Lower is better",

    rag: rag.value,
  },
]);
</script>
